(() => {
 const selectors='#menu-drawer, #menu-drawer .menu-drawer__submenu, #CartDrawer .drawer__inner, .cart-notification, dialog#cart, localization-form .country-selector, #case-lab-main .device-row, #case-lab-main .case-info, #case-lab-main .artwork-album > summary, #case-lab-main .case-controls .add, #artworkSearch, .shej-variant-trigger, .shej-variant-menu, product-info .quantity, product-info .product-form__submit';
 if(document.body.dataset.shejSurfacesReady)return;
 document.body.dataset.shejSurfacesReady='true';
 function decorate(root){
  const fields=[...(root.matches?.(selectors)?[root]:[]),...root.querySelectorAll(selectors)];
  for(const field of fields){
   if(field.querySelector(':scope > .shej-surface'))continue;
   field.classList.add('shej-has-surface');
   const style=getComputedStyle(field);
   // Drawer/popup CSS can arrive after this deferred script on lightweight pages.
   // Only in-flow panels need a containing block; never reposition navigation or dialogs.
   if(style.position==='static'&&field.matches('#CartDrawer .drawer__inner, #case-lab-main .device-row, #case-lab-main .case-info, #case-lab-main .artwork-album > summary, #case-lab-main .case-controls .add, #artworkSearch'))field.classList.add('shej-surface-positioned');
   const layer=document.createElement('i');
   layer.className='shej-surface';layer.setAttribute('aria-hidden','true');
   layer.style.setProperty('--surface-radius',style.borderRadius||'0px');
   field.prepend(layer);
  }
 }
 decorate(document);
 const observer=new MutationObserver(records=>{
  for(const record of records){
   if(record.target.matches?.(selectors)&&!record.target.querySelector(':scope > .shej-surface'))decorate(record.target);
   for(const node of record.addedNodes)if(node.nodeType===1&&!node.classList.contains('shej-surface'))decorate(node);
  }
 });
 observer.observe(document.body,{childList:true,subtree:true});
})();
